import React from 'react'
import TableWidget1 from './TableWidget1'
import flags from '../json/navbar-flags.json'

const SampleTableWidget1 = () => <TableWidget1 items={flags} amount={5} />

export default SampleTableWidget1
